//extracted by mini-css-extract-plugin
export default {"customHeaderLabel":"CustomColumnHeader_customHeaderLabel__Qyr7X"};;